export const RISK_PROFILE_FLUCTUATIONS = [
    {
        id: '8',
        pessimistic: -11,
        median: 5.3,
        optimistic: 19,
    },
    {
        id: '9',
        pessimistic: -13,
        median: 6.3,
        optimistic: 20,
    },
    {
        id: '10',
        pessimistic: -21,
        median: 7.8,
        optimistic: 27,
    },
    {
        id: '11',
        pessimistic: -31,
        median: 9.2,
        optimistic: 38,
    },
    {
        id: '12',
        pessimistic: -47,
        median: 11.7,
        optimistic: 54,
    },
];
